import { render, staticRenderFns } from "./SubDashboardContent.vue?vue&type=template&id=56d350ab&"
import script from "./SubDashboardContent.vue?vue&type=script&lang=ts&"
export * from "./SubDashboardContent.vue?vue&type=script&lang=ts&"
import style0 from "./SubDashboardContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports